export default __webpack_public_path__ + "static/media/Thank you.7adedb75.png";